import React from 'react';

function Hello({ name }) {
    return <h1>Hello, {name}!</h1>;
}

export default Hello;
